import React from 'react';
import styled from 'styled-components';

export interface LevelIndicatorProps extends StyledLevelIndicatorProps {
  total: number;
  level: number;
  className?: string;
}

export const LevelIndicator = ({
  total,
  level,
  border,
  color,
  secondary,
  className,
}: LevelIndicatorProps) => {
  return (
    <StyledLevelIndicator
      className={className || 'level-indicator'}
      border={border}
      color={color}
      secondary={secondary}
    >
      {[...Array(total)].map((_, i) => (
        <div key={i} className={i < (level / total) * total ? 'level' : ''} />
      ))}
    </StyledLevelIndicator>
  );
};

interface StyledLevelIndicatorProps {
  border?: string;
  color: string;
  secondary: string;
}

const StyledLevelIndicator = styled.div<StyledLevelIndicatorProps>`
  display: flex;
  height: 6px;
  div {
    &.level {
      background: ${({ color }) => color};
      border: 1px solid ${({ border, color }) => (border ? border : color)};
    }
    background: ${({ secondary }) => secondary};
    border: 1px solid
      ${({ border, color, secondary }) => (border ? color : secondary)};
    flex: 1 1 auto;
    margin-right: 4px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
